import React from "react";

export const RestaurantAddress = (props) => {
    const address = props.address;
    return (
        <div className="row text-black">
            <div className="col-lg-6 col-xl-6 col-xxl-6 col-12 alert alert-dismissible text-black">
            <div className="h6">
                <span>{address.city}, {address.state}</span>
            </div>

            <span>{address.postal_code}, {address.street}</span>
            <span>{address.formatted}</span>
            </div>
            <div className="col-lg-6 col-xl-6 col-xxl-6">

            </div>
            
        </div>
    );
};
